import { useLayoutEffect, useState } from "react"
import ReactDOM from "react-dom"

export const PortalHeader = ({
  children,
}: {
  children: JSX.Element | JSX.Element[]
}) => {
  const [elem, setElem] = useState<HTMLElement>()

  useLayoutEffect(() => {
    const elem = document.getElementById("header-element")
    setElem(elem)
  }, [])

  if (elem) {
    return ReactDOM.createPortal(children, elem)
  }
  return null
}
